/**
 * StatusChip — colored badge for DocAI document + run statuses.
 */
import React from 'react';
import { Badge } from '@chakra-ui/react';

const STYLES = {
  // document statuses
  auto_accept: { colorScheme: 'green', label: 'auto accept' },
  accept_with_warnings: { colorScheme: 'yellow', label: 'warnings' },
  review: { colorScheme: 'orange', label: 'review' },
  error: { colorScheme: 'red', label: 'error' },
  verified: { colorScheme: 'purple', label: 'verified' },
  queued: { colorScheme: 'gray', label: 'queued' },
  processing: { colorScheme: 'blue', label: 'processing' },
  unrouted: { colorScheme: 'cyan', label: 'unrouted' },
  // run statuses
  running: { colorScheme: 'blue', label: 'running' },
  done: { colorScheme: 'green', label: 'done' },
  cancelled: { colorScheme: 'gray', label: 'cancelled' },
};

export default function StatusChip({ status, ...rest }) {
  const s = STYLES[status] || { colorScheme: 'gray', label: status || '—' };
  return (
    <Badge colorScheme={s.colorScheme} variant="subtle" borderRadius="md" px={2} {...rest}>
      {s.label}
    </Badge>
  );
}
